import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { MenuItem, Typography, Tooltip as MuiTooltip } from '@mui/material'
import { withStyles } from '~/themes/useStyles'
import Checkbox from '~/components/common/Checkbox'
import style from './style'
import Tooltip from '~/components/common/Tooltip'

const Option = ({ classes, onClick, data, selected, multiple }) => {
  if (data.isGroupLabel) {
    return (
      <Typography
        key={data.value}
        variant="subtitle2"
        className={classes.groupLabel}
      >
        {data.label}
      </Typography>
    )
  }

  const [isOverflowed, setIsOverflow] = useState(false)
  const labelRef = useRef(null)
  const subLableRef = useRef(null)

  const title = (
    <>
      <span>{data.label || ''}</span>
      <br />
      {data.subLabel && <span>{data.subLabel}</span>}
    </>
  )

  useEffect(() => {
    setIsOverflow(
      labelRef.current.scrollWidth > labelRef.current.clientWidth ||
        subLableRef?.current?.scrollWidth > subLableRef?.current?.clientWidth,
    )
  }, [title])

  return (
    <MuiTooltip
      title={title}
      placement="right"
      disableHoverListener={!isOverflowed}
      classes={{
        tooltip: classes.tooltip,
      }}
    >
      <MenuItem
        classes={{
          root: clsx(classes.option, {
            [classes.optionWithCheck]: multiple,
          }),
        }}
        onClick={(e) => {
          e.preventDefault()
          onClick()
        }}
        selected={selected && !multiple}
        disabled={data.disabled}
        component="div"
      >
        {multiple && (
          <Checkbox className={classes.checkbox} checked={selected} />
        )}
        <div className={classes.labelContainer}>
          <div ref={labelRef} className={classes.label}>
            {data.label || ''}
            {data?.tooltip ? (
              <Tooltip
                icon={<img src="/icons/tip.svg" alt="tip" />}
                content={data?.tooltip || ''}
                placement="bottom"
              />
            ) : null}
          </div>
          {data.subLabel && (
            <div ref={subLableRef} className={classes.subLabel}>
              {data.subLabel}
            </div>
          )}
        </div>
      </MenuItem>
    </MuiTooltip>
  )
}

Option.defaultProps = {
  onClick: () => {},
  data: {},
  selected: false,
  multiple: false,
}

Option.propTypes = {
  classes: PropTypes.shape().isRequired,
  onClick: PropTypes.func,
  data: PropTypes.shape(),
  selected: PropTypes.bool,
  multiple: PropTypes.bool,
}

export default React.memo(withStyles(style)(Option))
